import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthHelperService } from './services/auth-helper.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterModule]
})
export class AppComponent implements OnInit{
  isIframe = false;

  constructor(private readonly authService: MsalService,
              private readonly authHelper: AuthHelperService, 
              private readonly router: Router
            ){}

  ngOnInit(): void {  
    if (typeof window !== 'undefined') {  
      this.isIframe = window !== window.parent && !window.opener;  
      const isAuthenticated = this.authService.instance.getActiveAccount(); 
      this.authHelper.isAuthenticated = true; 

      if (!isAuthenticated) {  
        this.authHelper.isAuthenticated = false;
        this.router.navigate(['']);
      } 
    } 
  }    
}
